function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "industry logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 14.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "industry logo",
    d: "m12 7.4-6.8 2.72v9.2h2.4v-5.2a1.2 1.2 0 0 1 1.2-1.2h6.4a1.2 1.2 0 0 1 1.2 1.2v5.2h2.4v-9.2zM8.8 20.52H5.2a1.2 1.2 0 0 1-1.2-1.2v-9.18a1.157 1.157 0 0 1 .21-.68 1.229 1.229 0 0 1 .55-.44l6.8-2.72a1.018 1.018 0 0 1 .88 0l6.8 2.72a1.229 1.229 0 0 1 .55.44 1.157 1.157 0 0 1 .21.68v9.18a1.2 1.2 0 0 1-1.2 1.2h-3.6v-6.4H8.8zm1 0v-1.2H11v1.2zm1.6-2.4v-1.2h1.2v1.2zm1.6 2.4v-1.2h1.2v1.2zm2.2-7.6z",
    transform: "translate(-4 -6.2)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedIndustry);
export default __webpack_public_path__ + "static/media/detailed-industry.ec781d96544642bc0ddf8506efbf42cc.svg";
export { ForwardRef as ReactComponent };